module.exports = __webpack_public_path__ + "img/1-md.f22f4e34.jpg";